module.exports = __webpack_public_path__ + "img/headLeft1Logo.40806a8c.png";